// PhoneEmailMenuRenderer.jsx
import React, { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from "react-i18next";
import { MdOutlineEmail, MdOutlinePhone, MdContentCopy, MdOutlineWhatsapp, MdOutlineSms } from "react-icons/md";
import { normalizePhone } from '../../../../util/functions'

const linkColor = '#1976d2';
const underline = 'underline';

const PhoneEmailMenuRenderer = (props) => {
    // const { value, onAction, fieldName, data } = props;   // ← new props
    const { value: rawValue, onAction, fieldName, data } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [t] = useTranslation('crm')
    const open = Boolean(anchorEl);
    const value = rawValue?.includes('@') ? rawValue : normalizePhone(rawValue);

    const toggleMenu = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setAnchorEl(open ? null : e.currentTarget);
    };

    const handleClose = () => setAnchorEl(null);

    const onMenuItemClickHandler = (action, e) => {
        e.stopPropagation();
        onAction?.({ action, value, fieldName, row: data });  // ← notify parent
        handleClose();
    };

    return (
        <div
            className={`crm-clickable-cell ${open ? 'menu-open' : ''}`}
            onClick={toggleMenu}
            style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                padding: '0 8px',
                cursor: 'pointer',
                userSelect: 'none',
            }}
        >
            <span
                style={{
                    color: linkColor,
                    textDecoration: open ? underline : 'none',
                }}
                onMouseEnter={(e) => e.currentTarget.style.textDecoration = underline}
                onMouseLeave={(e) => e.currentTarget.style.textDecoration = open ? underline : 'none'}
            >
                {value}
            </span>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                sx={{ '& .MuiPaper-root': { minWidth: 160 }, direction: 'ltr' }}
            >
                <MenuItem onClick={(e) => onMenuItemClickHandler('copy', e)}>
                    <MdContentCopy />
                    <span style={{ 'marginRight': '5px' }}> {t('Copy')}</span>
                </MenuItem>
                {value && value?.includes('@') &&
                    <MenuItem onClick={(e) => onMenuItemClickHandler('mail', e)}>
                        <MdOutlineEmail />
                        <span style={{ 'marginRight': '5px' }}> {t('Send email')}</span>
                    </MenuItem>}
                {value && value?.match(/^[\d+\-()\s]+$/) &&
                    <>
                        <MenuItem onClick={(e) => onMenuItemClickHandler('call', e)}>
                            <MdOutlinePhone />
                            <span style={{ 'marginRight': '5px' }}> {t('Call')}</span>
                        </MenuItem>
                        <MenuItem onClick={(e) => onMenuItemClickHandler('whatsapp', e)}>
                            <MdOutlineWhatsapp />
                            <span style={{ 'marginRight': '5px' }}> {t('Whatsapp')}</span>
                        </MenuItem>
                        <MenuItem onClick={(e) => onMenuItemClickHandler('sms', e)}>
                            <MdOutlineSms />
                            <span style={{ 'marginRight': '5px' }}> {t('Sms')}</span>
                        </MenuItem>
                    </>
                }
            </Menu>
        </div>
    );
};

export default PhoneEmailMenuRenderer;
